// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container__qrXCJ","title":"index_title__ZzeBK","desc":"index_desc__KDekz","countryList":"index_countryList__ogInP"};